import React from 'react';
import { ToggleSwitch as WixToggleSwitch } from '@wix/design-system';

export interface ToggleSwitchProps {
  checked?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  dataHook?: string;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
}

// this needs to be a class, because I need to use `ref` on it
export class ToggleSwitch extends React.Component<ToggleSwitchProps> {
  public id: string;

  public render() {
    return <WixToggleSwitch {...this.props} />;
  }
}

export default ToggleSwitch;
